import React from 'react';
import { Section, FadeIn, Button } from './ui';
import { Heart } from 'lucide-react';
export const EmotionalCloseSection = () => {
  return <Section bg="bg-cream-light" data-id="element-104">
      <FadeIn data-id="element-105">
        <div className="max-w-3xl mx-auto text-center" data-id="element-106">
          <div className="w-16 h-16 bg-coral/20 rounded-full flex items-center justify-center mx-auto mb-8" data-id="element-107">
            <Heart className="w-8 h-8 text-coral" data-id="element-108" />
          </div>

          <h2 className="text-3xl md:text-5xl font-bold mb-10 leading-tight text-brown" data-id="element-109">
            Llevas demasiado tiempo sintiéndote así.
          </h2>

          <div className="space-y-3 text-lg md:text-xl text-brown-light leading-relaxed mb-10" data-id="element-110">
            <p data-id="element-111">Demasiadas mañanas pesadas.</p>
            <p data-id="element-112">Demasiados días a medias.</p>
            <p data-id="element-113">
              Demasiadas veces diciéndote que ya va a mejorar — y esperando que
              algo cambie sin hacer nada diferente.
            </p>
          </div>

          <div className="bg-white border border-cream-dark rounded-3xl p-8 md:p-12 mb-10 shadow-sm" data-id="element-114">
            <p className="text-2xl md:text-3xl font-bold text-brown mb-6 leading-snug" data-id="element-115">
              Hoy puedes hacer algo diferente.
            </p>
            <p className="text-lg md:text-xl text-brown-light mb-2" data-id="element-116">
              No tienes que sentirte perfecta para empezar.
            </p>
            <p className="text-lg md:text-xl text-brown-light mb-6" data-id="element-117">
              Solo tienes que dar un paso.
            </p>
            <p className="text-xl md:text-2xl text-gold font-bold italic" data-id="element-118">
              Este es ese paso.
            </p>
          </div>

          <Button className="mx-auto" href="https://pay.hotmart.com/W105376697A" onClick={() => {
          try {
            const fbq = (window as any).fbq;
            if (fbq) fbq('track', 'AddToCart', {
              currency: 'USD',
              value: 17,
              content_name: 'Plan de 21 Días de Vitalidad Menopáusica',
              content_type: 'product'
            });
          } catch (e) {}
        }} data-id="element-119">
            ¡SÍ, QUIERO RECUPERAR MI ENERGÍA AHORA!
          </Button>

          <p className="mt-6 text-sm text-brown-light/70" data-id="element-120">
            Acceso instantáneo · Garantía de 7 días · Pago 100% seguro
          </p>
        </div>
      </FadeIn>
    </Section>;
};